import { useMemo } from 'react';

import { ChatConversation } from './useChat';
import { GroupedConversations } from './useGroupedConversations';

export const useConversationSearch = (
  groupedConversations: GroupedConversations,
  searchQuery: string
): GroupedConversations =>
  useMemo(() => {
    if (!searchQuery.trim()) return groupedConversations;

    const query = searchQuery.toLowerCase();
    const filter = (conversations: ChatConversation[]) =>
      conversations.filter((conversation) =>
        conversation.title.toLowerCase().includes(query)
      );

    return {
      today: filter(groupedConversations.today),
      previous7Days: filter(groupedConversations.previous7Days),
      previous30Days: filter(groupedConversations.previous30Days),
      older: filter(groupedConversations.older),
    };
  }, [groupedConversations, searchQuery]);
